/**
 * dnt.ts — Do Not Track / Global Privacy Control check.
 *
 * Contract (§10):
 *   - If DNT or GPC is set, suppress ALL three telemetry streams (no events
 *     queued or sent). The suppression check runs at track() time so it
 *     respects runtime changes (e.g. the user turns DNT on in a running session).
 */

/**
 * Returns true if the user has expressed a tracking-opt-out preference via
 * Do Not Track (navigator.doNotTrack) or the Global Privacy Control
 * (navigator.globalPrivacyControl).
 */
export function isDntActive(): boolean {
  if (typeof navigator === 'undefined') return false;

  // Do Not Track: "1" means opted out. "0" or null means no preference.
  const dnt = (navigator as { doNotTrack?: string | null }).doNotTrack;
  if (dnt === '1') return true;

  // Global Privacy Control (GPC): true means opted out.
  // navigator.globalPrivacyControl is a non-standard property; cast to access.
  const gpc = (navigator as { globalPrivacyControl?: boolean }).globalPrivacyControl;
  if (gpc === true) return true;

  return false;
}
